import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import Joi from 'joi'
import { AppointmentType, AvailabilityType } from '../../../constants'
import { AvailabilityConstraintUpsertRequest } from '../../../types'

const bool = Joi.bool()
const number = Joi.number()
const string = Joi.string()
const nullableString = string.allow(null, '')

const availabilityType = Joi.string()
  .uppercase()
  .valid(...Object.values(AvailabilityType))

const appointmentType = Joi.string()
  .uppercase()
  .valid(...Object.values(AppointmentType))

const appointmentTypesArray = Joi.array().items(appointmentType).min(1)

const appointment_types = Joi.any().when('availability_type', {
  is: AvailabilityType.UNAVAILABLE,
  then: Joi.forbidden(),
  otherwise: appointmentTypesArray.required(),
})

const deliveryModel = Joi.string()
  .uppercase()
  .valid(...Object.values(DeliveryModel))

const delivery_models = Joi.array().items(deliveryModel).min(1)

const availabilityConstraintUpsertSchema = Joi.object<AvailabilityConstraintUpsertRequest>({
  appointment_types,
  availability_type: Joi.any().when('isNew', {
    is: true,
    then: availabilityType.required(),
    otherwise: Joi.forbidden(),
  }),
  delivery_models,
  duration_in_minutes: number.min(15).required(),
  isNew: bool.optional(),
  recurrence_rule: nullableString.optional(),
  is_all_day: bool.optional(),
}).required()

export { availabilityConstraintUpsertSchema }
